import apiClient from "./axios.config";

const surveyService = {
  getSurveyStatus({ userGuid, deviceId } = {}) {
    const params = {};
    if (userGuid) params.userGuid = userGuid;
    if (deviceId) params.deviceId = deviceId;
    return apiClient.get("/website/survey/status", { params });
  },

  submitSurvey(payload) {
    return apiClient.post("/website/survey/submit", payload);
  },
};

export default surveyService;
